import { COMPANY_CONTACT } from "../constants/data";
import { fonts } from "../constants/theme";

export default function SuggestionsPage() {
  const sendSuggestion = (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const name = form.get("name") || "Prefiero no indicar mi nombre";
    const contact = form.get("contact") || "No indicado";
    const category = form.get("category");
    const suggestion = form.get("suggestion");
    const message = [
      "Hola VittaLink, quiero compartir una sugerencia.",
      `Nombre: ${name}`,
      `Contacto: ${contact}`,
      `Tema: ${category}`,
      `Sugerencia: ${suggestion}`,
    ].join("\n");
    const url = `https://wa.me/${COMPANY_CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="suggestions-page" style={{ minHeight: "100vh", padding: "7rem 20px 5rem", background: "#ffffff", position: "relative", overflow: "hidden" }}>
      <style>{`
        .suggestions-layout { display: grid; grid-template-columns: .9fr 1.1fr; gap: 3.5rem; align-items: center; }
        .suggestion-form-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
        .suggestion-field { width: 100%; box-sizing: border-box; border: 1px solid #dce7df; border-radius: 13px; background: #fbfdfb; padding: 13px 14px; color: #163120; font: 500 .92rem ${fonts.body}; outline: none; transition: border-color .2s ease, box-shadow .2s ease; }
        .suggestion-field:focus { border-color: #4aab65; box-shadow: 0 0 0 4px rgba(74,171,101,.12); }
        .suggestion-label { display: block; color: #263b2d; font: 700 .83rem ${fonts.body}; margin-bottom: 7px; }
        @media (max-width: 760px) {
          .suggestions-page { padding: 6.5rem 14px 3.5rem !important; }
          .suggestions-layout { grid-template-columns: 1fr; gap: 1.5rem; }
          .suggestions-copy { text-align: center; }
          .suggestions-copy p { margin-left: auto !important; margin-right: auto !important; }
          .suggestion-form-card { padding: 1.25rem !important; }
          .suggestion-form-fields { grid-template-columns: 1fr !important; gap: 12px !important; }
        }
      `}</style>

      <div style={{ position: "absolute", width: 400, height: 400, top: -210, right: "-8%", borderRadius: "50%", background: "rgba(83, 177, 101, .09)", filter: "blur(75px)", pointerEvents: "none" }} />
      <div className="suggestions-layout" style={{ width: "min(1080px, 100%)", margin: "0 auto", position: "relative" }}>
        <div className="suggestions-copy">
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 13px", borderRadius: 99, background: "#eff8ef", border: "1px solid #d8ebd9", color: "#267641", font: `800 .72rem ${fonts.body}`, letterSpacing: ".12em", textTransform: "uppercase" }}>
            Tu voz cuenta
          </span>
          <h1 style={{ color: "#12271a", font: `900 clamp(2.2rem, 5vw, 3.5rem)/1.06 ${fonts.display}`, letterSpacing: "-.04em", margin: "1.2rem 0 1rem" }}>
            Ayúdanos a hacerlo <span style={{ color: "#258447" }}>mejor.</span>
          </h1>
          <p style={{ maxWidth: 430, color: "#627368", font: `400 1rem/1.75 ${fonts.body}`, margin: 0 }}>
            Cuéntanos qué te gustaría ver en VittaLink. Leemos tus ideas sobre productos, ubicaciones, la app y tu experiencia.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 26, color: "#43724f", font: `600 .85rem ${fonts.body}` }}>
            <span style={{ width: 38, height: 38, display: "grid", placeItems: "center", borderRadius: 13, background: "#edf7ed", color: "#278448" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8A8.5 8.5 0 0 1 8.7 3.9a8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5Z" /></svg>
            </span>
            Se enviará por WhatsApp para que puedas revisarla antes.
          </div>
        </div>

        <form className="suggestion-form-card" onSubmit={sendSuggestion} style={{ padding: "2rem", border: "1px solid #e2ebe3", borderRadius: 24, background: "#ffffff", boxShadow: "0 22px 60px rgba(23, 59, 34, .1)" }}>
          <h2 style={{ margin: "0 0 1.35rem", color: "#193323", font: `800 1.25rem ${fonts.display}` }}>Comparte tu sugerencia</h2>

          <div className="suggestion-form-fields">
            <label>
              <span className="suggestion-label">Nombre <span style={{ color: "#849187", fontWeight: 500 }}>· opcional</span></span>
              <input className="suggestion-field" name="name" type="text" maxLength="80" placeholder="¿Cómo te llamas?" />
            </label>
            <label>
              <span className="suggestion-label">Contacto <span style={{ color: "#849187", fontWeight: 500 }}>· opcional</span></span>
              <input className="suggestion-field" name="contact" type="text" maxLength="100" placeholder="Correo o teléfono" />
            </label>
          </div>

          <label style={{ display: "block", marginTop: 15 }}>
            <span className="suggestion-label">¿Sobre qué tema?</span>
            <select className="suggestion-field" name="category" defaultValue="Experiencia general">
              <option>Experiencia general</option>
              <option>Productos y nutrición</option>
              <option>Ubicación de máquinas</option>
              <option>Aplicación móvil</option>
              <option>Otra idea</option>
            </select>
          </label>

          <label style={{ display: "block", marginTop: 15 }}>
            <span className="suggestion-label">Tu sugerencia</span>
            <textarea className="suggestion-field" name="suggestion" rows="5" minLength="8" maxLength="1200" placeholder="Escribe aquí tu idea o cuéntanos cómo podemos mejorar…" required style={{ resize: "vertical", minHeight: 125 }} />
          </label>

          <button type="submit" style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: 9, marginTop: 18, padding: "14px 18px", border: "none", borderRadius: 999, background: "#c8f135", color: "#18341f", font: `800 .95rem ${fonts.body}`, cursor: "pointer", boxShadow: "0 8px 20px rgba(126, 169, 39, .2)" }}>
            Continuar por WhatsApp
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </button>
          <p style={{ color: "#819086", textAlign: "center", font: `500 .73rem/1.5 ${fonts.body}`, margin: "12px 0 0" }}>WhatsApp se abrirá con tu mensaje listo para enviar.</p>
        </form>
      </div>
    </section>
  );
}
